import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/login/Login";
import EnterMobile from "./pages/rest-password/EnterMobile";
import EnterOtp from "./pages/rest-password/EnterOtp";
import CreatePassword from "./pages/rest-password/CreatePassword";

import MainPage from "./pages/dashboard/MainPage";
import ProtectedRoute from "./pages/login/ProtectedRoute";
import RecentWorks from "./pages/RecentWorks";
import Teams from "./pages/Teams";
import Machineries from "./pages/Machineries";
import Feedback from "./pages/Feedback";
import Services from "./pages/Services";
import MainTitle from "./pages/MainTitle";
import Marquee from "./pages/Marquee";
import HappyClient from "./pages/HappyClient";
import FeedbackSetting from "./pages/FeedbackSetting";
import PdfUpload from "./pages/PdfUpload";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<EnterMobile />} />
        <Route path="/otp-send" element={<EnterOtp />} />
        <Route path="/create-password" element={<CreatePassword />} />

        {/* Protected Admin Routes */}
        <Route path="/admin" element={<ProtectedRoute><MainPage title="Recent Works  Management"><RecentWorks /></MainPage></ProtectedRoute>}/>
        <Route path="/admin-teams" element={<ProtectedRoute><MainPage title="Teams  Management"><Teams /></MainPage></ProtectedRoute> }/>
        <Route path="/admin-machineries" element={<ProtectedRoute><MainPage title="Machineries  Management"><Machineries /></MainPage></ProtectedRoute>}/>
        <Route path="/admin-feedback" element={<ProtectedRoute><MainPage title="Feedback  Management"><Feedback /></MainPage></ProtectedRoute>}/>
        <Route path="/admin-service" element={<ProtectedRoute><MainPage title="Services  Management"><Services /></MainPage></ProtectedRoute>}/>
         <Route path="/admin-main-setting" element={<ProtectedRoute><MainPage title="Main Title  Management"><MainTitle /></MainPage></ProtectedRoute>}/>
          <Route path="/admin-marquee-setting" element={<ProtectedRoute><MainPage title="Marquee  Management"><Marquee /></MainPage></ProtectedRoute>}/>
          <Route path="/admin-happy-client" element={<ProtectedRoute><MainPage title="Happy Client  Management"><HappyClient /></MainPage></ProtectedRoute>}/>
          <Route path="/admin-feedback-setting" element={<ProtectedRoute><MainPage title="Feedback Setting  Management"><FeedbackSetting /></MainPage></ProtectedRoute>}/>
          <Route path="/admin-pdf-upload" element={<ProtectedRoute><MainPage title="PDF Upload  Management"><PdfUpload /></MainPage></ProtectedRoute>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
